import { useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { SelectField } from "../../../core/select-field.component";
import { useGetZones } from "../../../apiclient/master/useGetZoneApi";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useGetDroppingPoint } from "../../../apiclient/party/useGetDropingPointApi";
import { formatDate } from "@progress/kendo-intl";
import axios from "axios";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { API_END_POINT } from "../../../constants";
import { getDataWithToken, getEndPoint } from "../../../Utils/network.client";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { useGetCompanyDetails } from "../../../apiclient/master/useGetCompanydetailsApi";

export const UnionWiseEntryCheckListReport: React.FC = () => {
  const [sessionData, setSessionData] = useState<
    { value: string; label: string }[]
  >([]);
  const { data: fetchedSession } = useGetSessions();

  const excelExportRef = useRef<ExcelExport | null>(null);
  const pdfExportRef = useRef<PDFExport | null>(null);
  const [selectedSessionName, setSelectedSessionName] = useState<string>("");
  const [customerType, setCustomerType] = useState(1);

  const { data: companyDetails, isLoading: isCompanyLoading } =
    useGetCompanyDetails();
  const companyName = companyDetails?.[0]?.companyName || "Company Name";

  const exportToPDF = () => {
    if (pdfExportRef.current) {
      pdfExportRef.current.save();
    }
  };

  useEffect(() => {
    if (fetchedSession) {
      const mappedSession = fetchedSession.map((session: any) => ({
        value: session.sessionId,
        label: session.name,
      }));
      setSessionData(mappedSession);
    }
  }, [fetchedSession]);

  const [fromDate1, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );
  const [fromDate2, setFromDate2] = useState<string>("");
  const [gridData, setGridData] = useState([]);
  const [columns, setColumns] = useState([]);

  const initialValues = {
    sessionId: "",
    fromDate: fromDate1,
  };

  const [sessionid, setSessionId] = useState([]);

  const handleunionwisesummary = async () => {
    try {
      setGridData([]);

      const apiUrl = `${getEndPoint(
        API_END_POINT.REPORT
      )}/api/DailyReportsService/GetUnionWiseEntryCheckList/${fromDate2}/${sessionid}`;

      const response = await getDataWithToken<any>(apiUrl);
      // const response = await axios.get(apiUrl);

      if (response.data.jsonstring) {
        const parsedData = JSON.parse(response.data.jsonstring);

        const columnHeaders: string[] = Object.values(
          parsedData.header[0]
        ) as string[];
        const updatedColumns = ["SNo", ...columnHeaders];
        setColumns(updatedColumns);

        if (parsedData.details != null) {
          //   const transformedData = parsedData.details.map((row: Record<string, any>, index: number) => {
          //     let newRow: Record<string, any> = { "SNo": index + 1 };

          //     Object.keys(row).forEach((key, index) => {
          //       // Replace routeid with routeName if available
          //       if (key === "routeid" && row[key]) {
          //         newRow["ROUTE"] = row["routeName"] || row[key]; // Default to routeid if routeName doesn't exist
          //       } else {
          //         newRow[columnHeaders[index]] = row[key];
          //       }
          //     });

          //     return newRow;
          //   });

          const transformedData = parsedData.details.map(
            (row: Record<string, any>, index: number) => {
              let newRow: Record<string, any> = {};

              Object.keys(row).forEach((key, idx) => {
                if (key === "routeid" && row[key]) {
                  newRow["ROUTE"] = row["routeName"] || row[key];
                } else {
                  newRow[columnHeaders[idx]] = row[key];
                }
              });

              if (index === 0) {
                newRow["SNo"] = 1;
              } else {
                newRow["SNo"] = "";
                newRow["uname"] = "";
              }

              return newRow;
            }
          );

          // Calculate totals for numeric columns
          const subtotalRow: Record<string, any> = {};
          columnHeaders.forEach((col) => {
            const total = transformedData.reduce(
              (sum: number, row: { [x: string]: string }) => {
                const value = parseFloat(row[col]);
                return !isNaN(value) ? sum + value : sum;
              },
              0
            );
            subtotalRow[col] =
              isNaN(total) || col === "uname" || col === "route"
                ? ""
                : total.toFixed(2);
          });

          // Append subtotal row to data
          transformedData.push({ ...subtotalRow, session: "Total" });
          setGridData(transformedData);

          console.log("Columns:", columns);
          console.log("Grid Data:", gridData);
        } else {
          console.error("No Records");
        }
      } else {
        console.error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const exportToExcel = () => {
    if (!excelExportRef.current) return;

    const options = excelExportRef.current.workbookOptions();
    const sheet = options.sheets[0];

    const formattedDate = fromDate1
      ? new Date(fromDate1).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
      : "";

    // Include session in heading
    const headingWithDate =
      `Union Wise Entry CheckList Report - ${formattedDate}` +
      (selectedSessionName ? ` - ${selectedSessionName}` : "");

    sheet.rows.unshift({
      cells: [
        {
          value: headingWithDate,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    // Add a single merged row for "DEV DCMPU" above the report heading
    sheet.rows.unshift({
      cells: [
        {
          value: companyName,
          colSpan: sheet.columns.length,
          bold: true,
          fontSize: 14,
          textAlign: "center",
        },
      ],
    });

    excelExportRef.current.save(options);
  };

  const handleSessionChange = (value: any) => {
    setSessionId(value);
    const selected = sessionData.find((s) => s.value === value);
    setSelectedSessionName(selected?.label || "");
    console.log("session id is:", value);
  };

  const handleDateChange = (value: any) => {
    const day = value.getDate().toString().padStart(2, "0");
    const month = value
      .toLocaleString("default", { month: "short" })
      .toUpperCase(); // Get short month (e.g., JAN)
    const year = value.getFullYear();

    const formattedDate = new Date(`${year}-${month}-${day}`);
    setFromDate(formattedDate);

    const formattedDate2 = dayjs(value).format("ddd MMM DD YYYY");
    console.log(formattedDate2);
    setFromDate2(formattedDate2);
  };

  useEffect(() => {
    if (fromDate1) {
      const formattedDate2 = dayjs(fromDate1).format("ddd MMM DD YYYY");
      console.log("Formatted Date:", formattedDate2);
      setFromDate2(formattedDate2);
    }
  }, [fromDate1]);
  const hasRecords = gridData.length > 0;

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <div
            className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
            style={{ minHeight: "500px" }}
          >
            <div className="top-sec-align row">
              <center>
                <h4 className="text-normal title-web mb-0 report-title-color">
                  Union Wise Entry CheckList Report
                </h4>
              </center>
            </div>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
              <div className="d-flex">
                <div className="me-2">
                  <label> Select Date</label>
                  <DatePicker
                    selectsMultiple={true}
                    openToDate={new Date()}
                    className="form-control ms-auto search-right-align calendarBg"
                    value={formatDate(fromDate1, "dd/MM/yyyy")}
                    placeholderText="To"
                    dateFormat={"dd/MM/yyyy"}
                    onChange={([date]: any) => {
                      handleDateChange(date);
                    }}
                  />
                </div>

                <div className="me-2">
                  <label>Select Session</label>
                  <SelectField
                    name="sessionId"
                    options={sessionData}
                    unSelectValue={0}
                    notifyChange={handleSessionChange}
                  />
                </div>

                <div>
                  <label></label>
                  <button
                    className="btn-primary btn search-btns mt-4"
                    type="submit"
                    onClick={() => {
                      handleunionwisesummary();
                    }}
                  >
                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                      <path
                        id="Path_magnify"
                        data-name="Path / magnify"
                        d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                        transform="translate(-3 -3)"
                        fill="#fff"
                      />
                    </svg>
                  </button>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToExcel}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "18px" }}
                  >
                    Export to Excel
                  </button>

                  <button
                    title="Export Excel"
                    className="export-button ms-2"
                    onClick={exportToPDF}
                    disabled={!hasRecords}
                    style={{ marginTop: "23px", marginBottom: "18px" }}
                  >
                    Export to PDF
                  </button>
                </div>
              </div>
            </div>
            <div>
              <PDFExport ref={pdfExportRef} fileName="Union Wise Entry Check List.pdf">
                <div style={{ padding: "10px", backgroundColor: "#fff" }}>
                  {/* Company Name */}
                  <div style={{ textAlign: "center", marginBottom: "5px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                      {companyDetails?.[0]?.companyName || "Company Name"}
                    </span>
                  </div>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "1.25rem" }}>
                      Union Wise Entry CheckList Report&nbsp;-
                      {fromDate1 && (
                        <>
                          {new Date(fromDate1).toLocaleDateString("en-IN", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                          })}
                        </>
                      )}
                      {selectedSessionName && ` - ${selectedSessionName}`}
                    </span>
                  </div>

                  {gridData.length > 0 && columns.length > 0 ? (
                    <Grid data={gridData} style={{ height: "auto" }} resizable>
                      <GridColumn
                        field="SNo"
                        title="S.No"
                        width="60px"
                        className={"text-center"}
                      />

                      <GridColumn field="uname" title="UNION" width="150px" />
                      <GridColumn field="route" title="ROUTE" width="160px" />

                      {columns
                        .filter(
                          (col) =>
                            col !== "SNo" &&
                            col !== "unionid" &&
                            col !== "uname" &&
                            col !== "route"
                        )
                        .map((col, index) => (
                          <GridColumn
                            key={index}
                            field={col}
                            title={col}
                            width="87px"
                            className={"text-end"}
                          />
                        ))}
                    </Grid>
                  ) : (
                    <p>No data Found</p>
                  )}
                </div>
              </PDFExport>

              <ExcelExport
                data={gridData}
                ref={excelExportRef}
                fileName="Union Wise Entry Check List.xlsx"
              >
                {columns
                  .filter((col) => col !== "unionid") // Exclude blockid and routeid columns
                  .map((col, index) => (
                    <ExcelExportColumn key={index} field={col} title={col} />
                  ))}
              </ExcelExport>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
